import type { XPluginOptions } from '@empathyco/x-components'
import type { XComponentsAdapter } from '@empathyco/x-types'
import type { Store } from 'vuex'
import { xPlugin } from '@empathyco/x-components'
import { FilterEntityFactory, SingleSelectModifier } from '@empathyco/x-components/facets'
import Vue from 'vue'

import { getAdapter } from './adapter'

function getPageSizeBasedOnScreenWidth(): number {
  const innerWidth = window.innerWidth
  if (innerWidth >= 3840) {
    // 4K resolution or bigger
    return 168
  } else if (innerWidth >= 2560) {
    // 2K resolution or bigger
    return 96
  } else if (innerWidth >= 1920) {
    // 1080p resolution or bigger
    return 48
  } else {
    return 24
  }
}

export function useX({
  store,
  endpoints,
  adapter = getAdapter(endpoints),
}: {
  store: Store<any>
  endpoints: {
    search: string
  }
  adapter?: Partial<XComponentsAdapter>
}): void {
  Vue.use(xPlugin, {
    adapter,
    store,
    xModules: {
      search: {
        config: {
          pageSize: getPageSizeBasedOnScreenWidth(),
        },
      },
    },
  } as XPluginOptions)

  FilterEntityFactory.instance.registerModifierByFilterModelName(
    'HierarchicalFilter',
    SingleSelectModifier,
  )
}
